import { render, staticRenderFns } from "./TopSellingProducts.vue?vue&type=template&id=364d1a68"
import script from "./TopSellingProducts.vue?vue&type=script&lang=js"
export * from "./TopSellingProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports